import React from 'react';
export const CookiePolicy = () => {
  return <div className="pt-20" data-id="element-2739" data-mp="28j1xhs0zska8">
      <section className="py-16 bg-secondary/5" data-id="element-2740" data-mp="2ot2kowsc6ypi">
        <div className="container mx-auto px-4" data-id="element-2741" data-mp="2ouckprir2gys">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-2742" data-mp="33qbst25v0h3x">
            Cookie Policy
          </h1>
          <p className="text-center text-secondary" data-id="element-2743" data-mp="2yqpbagj00epb">Last updated: 19|08|2025</p>
        </div>
      </section>
      <section className="py-16" data-id="element-2744" data-mp="3cq8cepde6ps4">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-2745" data-mp="3cp6z0e8wlr78">
          <div className="prose prose-lg max-w-none" data-id="element-2746" data-mp="37sou9edkpsuw">
            <p data-id="element-2747" data-mp="37q2p1le5npfu">
              The Networking Salon ("we," "our," or "us") uses cookies and
              similar technologies on our website to improve your browsing
              experience, analyze traffic, and provide relevant content. This
              Cookie Policy explains what cookies are, how we use them, and your
              choices.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2748" data-mp="3rh7cfc05w603">
              1. What Are Cookies?
            </h2>
            <p data-id="element-2749" data-mp="1xx8hmzqd3uhb">
              Cookies are small text files stored on your device when you visit
              a website. They help websites recognize your device, remember
              preferences, and improve functionality.
            </p>
            <p data-id="element-2750" data-mp="2bv5fdzgjy6xk">Cookies may be:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2751" data-mp="2bwggtsmiz2li">
              <li data-id="element-2752" data-mp="2gui1ghzln9z3">
                <strong data-id="element-2753" data-mp="2gv1jdyp91yd4">Session Cookies:</strong> Temporary, deleted when you
                close your browser.
              </li>
              <li data-id="element-2754" data-mp="2kusgsl9a7cqm">
                <strong data-id="element-2755" data-mp="2kuaf393uo6bb">Persistent Cookies:</strong> Stay on your device until
                deleted or they expire.
              </li>
              <li data-id="element-2756" data-mp="2uln65yhtqsga">
                <strong data-id="element-2757" data-mp="2um6bmfqafodf">First-Party Cookies:</strong> Placed by our website.
              </li>
              <li data-id="element-2758" data-mp="2zlj71ov863rm">
                <strong data-id="element-2759" data-mp="2zm2kas9xk3zb">Third-Party Cookies:</strong> Placed by external
                services (e.g., Google Analytics, social media).
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2760" data-mp="2evfcjhu2owry">
              2. How We Use Cookies
            </h2>
            <p data-id="element-2761" data-mp="29xna3tvsxs9i">We use cookies to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2762" data-mp="29yoxmxu08784">
              <li data-id="element-2763" data-mp="2oma1wv2m8chm">
                <strong data-id="element-2764" data-mp="2omtfy0p5agqd">Essential:</strong> Ensure our website functions
                properly (e.g., navigation, forms).
              </li>
              <li data-id="element-2765" data-mp="2jt73a8izecuk">
                <strong data-id="element-2766" data-mp="2xm6h86347z00">Analytics:</strong> Understand how visitors use our site
                to improve performance (e.g., Google Analytics).
              </li>
              <li data-id="element-2767" data-mp="2sn3q7pjyztb1">
                <strong data-id="element-2768" data-mp="2spprx8k6jelc">Preferences:</strong> Remember your settings (e.g.,
                language, event selections).
              </li>
              <li data-id="element-2769" data-mp="32l9pdzee6lc7">
                <strong data-id="element-2770" data-mp="32muidkl25w7y">Marketing:</strong> Deliver relevant promotions and
                measure the effectiveness of campaigns.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2771" data-mp="1881opr3qjfin">
              3. Third-Party Cookies
            </h2>
            <p data-id="element-2772" data-mp="3julpfm6jrlwf">We may use trusted third-party services, including:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2773" data-mp="3otyk2t3ntx9k">
              <li data-id="element-2774" data-mp="3otf43hxkliy6">Google Analytics for insights on website usage.</li>
              <li data-id="element-2775" data-mp="3a5u07lsvffp7">
                Social Media Plugins (e.g., LinkedIn, Instagram) for sharing and
                engagement.
              </li>
            </ul>
            <p data-id="element-2776" data-mp="3f1sn14yjwpni">
              These providers may set cookies according to their own privacy
              policies.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2777" data-mp="3567nrekva3hg">4. Your Choices</h2>
            <p data-id="element-2778" data-mp="2r6g34uzuhouh">You can manage or disable cookies by:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2779" data-mp="2r7r7ox1470mn">
              <li data-id="element-2780" data-mp="2w4rbt2eeltb4">
                Adjusting your browser settings to block or delete cookies.
              </li>
              <li data-id="element-2781" data-mp="pejq1gy146xl">
                Opting out of analytics/advertising cookies where applicable.
              </li>
            </ul>
            <p data-id="element-2782" data-mp="ud4uxto87esd">
              Please note: disabling cookies may affect website functionality.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2783" data-mp="2qeyg92uf4b84">
              5. Updates to This Policy
            </h2>
            <p data-id="element-2784" data-mp="2lg4yuzc0g02o">
              We may update this Cookie Policy to reflect changes in technology,
              legal requirements, or our practices. Updates will be posted on
              this page with a new "last updated" date.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2785" data-mp="27j8b56r6uyq0">6. Contact Us</h2>
            <p data-id="element-2786" data-mp="22qygxej1jchx">For questions about our use of cookies, please contact us:</p>
            <p data-id="element-2787" data-mp="1xsddz7cemeps">
              📧 Email:{' '}
              <a href="mailto:info@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-2788" data-mp="1xtezk5r1qjlr">
                info@thenetworkingsalon.live
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>;
};